import { render, staticRenderFns } from "./SocialSharingButtons.vue?vue&type=template&id=1114d978&scoped=true"
import script from "./SocialSharingButtons.vue?vue&type=script&lang=js"
export * from "./SocialSharingButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1114d978",
  null
  
)

export default component.exports